export const PROBLEM_BASE__PERMISSIONS = {
  PROBLEM_BASE: {
    VIEW: {
      permissionGroupName: 'Przeglądanie zadań w bazie zadań',
      NONE: {
        dbName: 'PROBLEM__PROBLEM_BASE__VIEW__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do zadań w publicznej bazie zadań.'
      },
      PUBLIC_RELATED_TO_GOALS: {
        dbName: 'PROBLEM__PROBLEM_BASE__VIEW__PUBLIC_RELATED_TO_GOALS',
        name: 'Opublikowane zadania w bazie zadań powiązane z celami użytkownika',
        description: 'Przeglądanie wszystkich publicznych zadań powiązanych z celami użytkownika.'
      },
      PRIVATE_RELATED_TO_GOALS: {
        dbName: 'PROBLEM__PROBLEM_BASE__VIEW__PRIVATE_RELATED_TO_GOALS',
        name: 'Nieopublikowane zadania innych użytkowników powiązane z celami użytkownika',
        description:
          'Przeglądanie wszystkich zadań (w tym zadań prywatnych innych użytkowników) powiązanych z celami użytkownika.'
      },
      ALL: {
        dbName: 'PROBLEM__PROBLEM_BASE__VIEW__ALL',
        name: 'Wszystkie zadania w bazie zadań powiązane z celami użytkownika',
        description:
          'Przeglądanie wszystkich zadań (włącznie z zadaniami prywatnymi innych użytkowników) w systemie.'
      }
    },
    MANAGE_PRIVATE: {
      permissionGroupName: 'Zarządzanie zadaniami w bazie zadań',
      NONE: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PRIVATE__NONE',
        name: 'Brak uprawnień',
        description:
          'Brak możliwości dodawania/edytowania/archiwizacji zadań w bazie zadań, włączając brak możliwości tworzenia własnych zadań.'
      },
      OWNED: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PRIVATE__OWNED',
        name: 'Własne',
        description: 'Dodawanie/edycja/archiwizacja własnych zadań.'
      },
      RELATED_TO_GOALS: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PRIVATE__RELATED_TO_GOALS',
        name: 'Powiązane z celami użytkownika',
        description:
          'Dodawanie/edycja/archiwizacja zadań prywatnych, utworzonych przez innych użytkowników, powiązanych z celami użytkownika.'
      },
      ALL: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PRIVATE__ALL',
        name: 'Wszystkie',
        description: 'Dodawanie/edycja/archiwizacja wszystkich zadań prywatnych.'
      }
    },
    MANAGE_PUBLIC: {
      permissionGroupName: 'Zarządzanie publicznymi zadaniami w bazie zadań',
      NONE: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PUBLIC__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania publicznymi zadaniami.'
      },
      OWNED: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PUBLIC__OWNED',
        name: 'Własne publiczne',
        description:
          'Dodawanie/edycja/archiwizacja publicznych zadań stworzonych przez użytkownika.'
      },
      RELATED_TO_GOALS: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PUBLIC__RELATED_TO_GOALS',
        name: 'Powiązane z celami użytkownika',
        description:
          'Dodawanie/edycja/archiwizacja publicznych zadań powiązanych z celami użytkownika.'
      },
      ALL: {
        dbName: 'PROBLEM__PROBLEM_BASE__MANAGE_PUBLIC__ALL',
        name: 'Wszystkie publiczne',
        description: 'Dodawanie/edycja/archiwizacja wszystkich publicznych zadań w bazie.'
      }
    },
    PUBLISH: {
      permissionGroupName: 'Publikowanie zadań do bazy zadań',
      NONE: {
        dbName: 'PROBLEM__PROBLEM_BASE__PUBLISH__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości publikacji zadań.'
      },
      ENABLED: {
        dbName: 'PROBLEM__PROBLEM_BASE__PUBLISH__ENABLED',
        name: 'Publikacja włączona',
        description: 'Publikacja zadania prywatnego do bazy zadań.'
      }
    }
  }
} as const
